import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom'

import { App } from '../App'
import { useAuth } from '../contexts/AuthContext'
import { AuthRoutes } from './expert/auth/AuthRoutes'
import { PrivateRoutes } from './expert/private/PrivateRoutes'

import { useEffect } from 'react'
import { UserType } from '../enumns/userType'
import { PrivacyPolicy } from '../pages/compliance/privacyPolicy'
import { TermsOfParticipation } from '../pages/compliance/termsOfParticipation'
import { TermsOfUse } from '../pages/compliance/termsOfUse'
import { ContactUs } from '../pages/contact'
import { AcceptTerms } from '../pages/expert/AcceptTerms'
import { Landing } from '../pages/landing/landing'
import { PainelAuthRoutes } from './painel/auth/PainelAuthRoutes'
import PainelPrivateRoutes from './painel/private/Routes'
import { Spinner } from '../components/Spinner'

export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export const AppRoutes = () => {
  const { user } = useAuth()

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<App />}>
          <Route path="/" element={<Landing />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route
            path="/terms-of-participation"
            element={<TermsOfParticipation />}
          />
          {user ? (
            <>
              {(user.type === UserType.ADMIN ||
                user.type === UserType.RESEARCHER) && (
                <>
                  <Route
                    path="/painel"
                    element={<Navigate to="/painel/dashboard" />}
                  />
                  <Route path="/painel/*" element={<PainelPrivateRoutes />} />
                  <Route
                    path="/expert/*"
                    element={<Navigate to="/painel/dashboard" />}
                  />
                </>
              )}
              {user.type === UserType.EXPERT &&
                !(user as any).hasAcceptedTerms && (
                  <>
                    <Route
                      path="expert/accept-terms"
                      element={<AcceptTerms />}
                    />
                    <Route
                      path="/expert/*"
                      element={<Navigate to="/expert/accept-terms" />}
                    />
                    <Route
                      path="/painel/*"
                      element={<Navigate to="/expert/meetings" />}
                    />
                  </>
                )}

              {user.type === UserType.EXPERT && (user as any).hasAcceptedTerms && (
                <>
                  <Route
                    path="/expert"
                    element={<Navigate to="/expert/meetings" />}
                  />
                  <Route path="/expert/*" element={<PrivateRoutes />} />
                  <Route
                    path="/painel/*"
                    element={<Navigate to="/expert/meetings" />}
                  />
                </>
              )}
              <Route path="*" element={<Navigate to="/expert" />} />
            </>
          ) : (
            <>
              <Route path="/painel/*" element={<PainelAuthRoutes />} />
              <Route
                path="/painel/logout"
                element={<Navigate to="/painel" />}
              />

              <Route path="/expert/*" element={<AuthRoutes />} />
              <Route
                path="/expert/logout"
                element={<Navigate to="/expert" />}
              />
              <Route path="*" element={<Navigate to="/expert" />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
